<div class="input-wrapper h-100 d-flex flex-column justify-content-between">
    <div class="d-flex align-items-center form-label">
        @if (legend || label) {
            <div class="input-wrapper__label d-flex align-items-top">
                @if (locked) {
                    <wdx-icon
                        data-cy="locked-icon"
                        class="text-muted me-2"
                        icon="lock"
                        iconStyle="fas"
                    ></wdx-icon>
                }
                @if (guidanceText) {
                    <div>
                        <i
                            class="icon guidance-icon me-2 fal fa-question-circle fa-1x text-muted"
                            role="button"
                            container="body"
                            [ngbPopover]="popContent"
                        ></i>
                    </div>
                }
                @if (isSensitive) {
                    <wdx-icon
                        data-cy="locked-sensitive"
                        class="text-muted me-2 pointer"
                        icon="shield-check"
                        iconStyle="fal"
                        [ngbPopover]="
                            TRANSLATION_POPOVER_SENSITIVLE_FIELD
                                | translateTokenisedString
                        "
                        container="body"
                    ></wdx-icon>
                }
                @if (legend) {
                    <legend class="h6">
                        <wdx-label
                            [label]="legend"
                            [required]="isRequired"
                            [labelForId]="labelForId || ''"
                        ></wdx-label>
                    </legend>
                }
                @if (label) {
                    <wdx-label
                        [label]="label"
                        [required]="isRequired"
                        [labelForId]="labelForId || ''"
                    ></wdx-label>
                }
            </div>
        }
        <div class="flex-grow-1 d-flex align-items-center justify-content-end">
            <ng-content select="[formFieldActionButton]"></ng-content>
        </div>
    </div>
    <div
        class="input-wrapper__content"
        [class.has-warning]="warningMessage"
        [class.is-invalid]="validationErrorMessage"
        [attr.data-cy]="'card-' + label"
    >
        <ng-content></ng-content>
        @if (validationErrorMessage) {
            <div
                class="input-wrapper__validation text-danger small mt-1"
                data-cy="validationErrorMessage"
            >
                {{ validationErrorMessage | translateTokenisedString }}
            </div>
        } @else if (warningMessage) {
            <div
                class="input-wrapper__validation text-warning small mt-1"
                data-cy="warningMessage"
            >
                {{ warningMessage }}
            </div>
        } @else {
            <div class="small mt-1">&nbsp;</div>
        }
    </div>
</div>

<ng-template #popContent>
    <div [innerHtml]="guidanceText | markdownToHtml | safeHtml"></div>
</ng-template>
